import React from 'react';
import { RhNumberField } from '../../../../../../../../dum';
import { IProduct } from '../../../product-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

export function PleatInput() {
    const inputName: keyof IProduct = 'pleat';

    return (
        <RhNumberField
            name={inputName}
            label={shortLabel(FIELD_LABELS.pleat)}
        />
    );
}
